import axios from "axios";
import type { AxiosRequestHeaders } from "axios";

import { Configuration } from "../../config/configuration";
import { useLoginClaim } from "../../hooks/useLoginClaim";
import { useLoginUser } from "../../hooks/useLoginUser";

export const microserviceApiAxios = axios.create();

microserviceApiAxios.interceptors.request.use((config) => {
  const { isLogin, credentials } = useLoginClaim();
  if (isLogin && credentials) {
    config.headers = (config.headers ?? {}) as AxiosRequestHeaders;
    config.headers.Authorization = `${credentials.type} ${credentials.token}`;
  }
  return config;
});

microserviceApiAxios.interceptors.request.use((config) => {
  const { isLogin, credentials } = useLoginUser();
  if (isLogin && credentials) {
    config.headers = (config.headers ?? {}) as AxiosRequestHeaders;
    config.headers.Authorization = `${credentials.type} ${credentials.token}`;
  }
  return config;
});

microserviceApiAxios.interceptors.request.use((config) => {
  const baseURL = Configuration.microservice.baseURL;
  return { baseURL, ...config };
});
